export const CHANGE_POINT_COURIER_FORM = Symbol('CHANGE_POINT_COURIER_FORM');
export const CHANGE_POINT_COURIER_FORM_REQUEST = Symbol('CHANGE_POINT_COURIER_FORM_REQUEST');
export const CHANGE_POINT_COURIER_FORM_SUCCESS = Symbol('CHANGE_POINT_COURIER_FORM_SUCCESS');
export const CHANGE_POINT_COURIER_FORM_ERROR = Symbol('CHANGE_POINT_COURIER_FORM_ERROR');

export const OPEN_COURIER_FORM = Symbol('OPEN_COURIER_FORM');
export const CLOSE_COURIER_FORM = Symbol('CLOSE_COURIER_FORM');


